module.exports = __webpack_public_path__ + "img/support_icon.5c4f4a96.svg";